import fr from './fr.json'
import en from './en.json'

export const languages = {
    fr: fr,
    en: en,
}